import React, { useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { useAnalytics } from 'hooks';
import { withAuth, withHuggg, withRedirect } from 'hoc';
import { Layout } from 'layouts';
import { Huggg, Reaction } from 'components';
import { PageTitle } from 'components/misc';
import { makeTitle, getBasePathname } from 'utilities/huggg';
import styles from './landing.module.scss';
import {
  GiftWrap,
  Divider,
  PrimaryButton,
  useThemeContext
} from '@huggg/react-components';
import { Link } from 'react-router-dom';
import {
  setHugggUnwrapped,
  isHugggUnwrapped,
  getVoucherExpiry
} from 'redux/modules/huggg';
import { ExpirationDate, PoweredByHuggg } from 'components/ui';
import HistoryService from 'services/HistoryService';
const history = new HistoryService();

export const ScreensLanding = props => {
  const {
    huggg,
    isAuthed,
    showDetails,
    setHugggUnwrapped,
    isHugggUnwrapped,
    voucherExpiry
  } = props;

  const {
    shouldShowPoweredByHuggg,
    isWelfare,
    landingPageButtonCopy
  } = useThemeContext();

  const analytics = useAnalytics();
  const backAction = useCallback(() => '/', []);

  const hugggTitle = useMemo(() => {
    return makeTitle(huggg);
  }, [huggg]);

  useEffect(() => {
    huggg.isSuperhuggg
      ? analytics.screenViewedSuperhugggLanding()
      : analytics.screenViewedHugggLanding();
  }, [analytics, huggg]);

  const onMoreInfoClicked = useCallback(() => {
    huggg.isSuperhuggg
      ? analytics.buttonClickSuperhugggActionsMoreInfo()
      : analytics.buttonClickHugggActionsMoreInfo();
  }, [analytics, huggg.isSuperhuggg]);

  const renderGiftUnwrapContent = () => (
    <div data-testid="giftwrap" className={styles.giftwrap}>
      <GiftWrap
        onUnwrapComplete={setHugggUnwrapped}
        senderMessage={hugggTitle}
      />
    </div>
  );

  const renderPageContent = () => (
    <>
      <div className="container" data-test-id="landing-screen-huggg">
        <Huggg huggg={huggg} data-test-id="landing-screen-huggg" />

        {shouldShowPoweredByHuggg && <PoweredByHuggg />}

        <Divider />

        <Reaction animate reactionDisabled />

        <Link
          onClick={onMoreInfoClicked}
          to={`${getBasePathname(huggg)}/more-information`}
          style={{ textDecoration: 'none' }}
        >
          <PrimaryButton
            label={landingPageButtonCopy}
            className={styles.moreInfoButton}
          />
        </Link>

        <ExpirationDate huggg={huggg} voucherExpiry={voucherExpiry} />
      </div>
    </>
  );

  return (
    <>
      <PageTitle huggg={huggg} />
      <Layout
        backAction={backAction}
        showBackButton={
          isAuthed &&
          !huggg.isSuperhuggg &&
          Boolean(history.getPreviousPathname())
        }
        showDetails={showDetails}
      >
        {isWelfare || isHugggUnwrapped
          ? renderPageContent()
          : renderGiftUnwrapContent()}
      </Layout>
    </>
  );
};

ScreensLanding.propTypes = {
  huggg: PropTypes.object.isRequired,
  isAuthed: PropTypes.bool.isRequired,
  isMultiRedeemable: PropTypes.bool.isRequired,
  isTestHuggg: PropTypes.bool.isRequired,
  showDetails: PropTypes.bool,
  setHugggUnwrapped: PropTypes.func.isRequired,
  isHugggUnwrapped: PropTypes.bool.isRequired,
  voucherExpiry: PropTypes.string
};

const mapStateToProps = state => ({
  isHugggUnwrapped: isHugggUnwrapped(state),
  voucherExpiry: getVoucherExpiry(state),
  showDetails: true
});

const redirectHandler = props => {
  const { huggg, isRedeemed, isMultiRedeemable } = props;
  const { isSuperhuggg, shortcode } = huggg;
  const url = isSuperhuggg ? `/super/${shortcode}` : shortcode;

  const shouldRedirect = !isSuperhuggg && !isMultiRedeemable && isRedeemed;

  return [shouldRedirect, `${url}/redeemed`];
};

const augmentedWithHuggg = screen =>
  withHuggg(screen, { forceRefresh: { huggg: false } });

export default compose(
  withAuth,
  augmentedWithHuggg,
  connect(mapStateToProps, { setHugggUnwrapped }),
  withRedirect(redirectHandler)
)(ScreensLanding);
